const DsmColor = {
  BackgroundPrimary: "var(--background-primary)",
  OverlayDark: "var(--overlay-dark)",
  OverlayMedium: "var(--overlay-medium)",
  OverlayLight: "var(--overlay-light)",
  ContentPrimary: "var(--content-primary)",
  ContentPrimaryHover: "var(--content-primary-hover)",
  ContentSecondary: "var(--content-secondary)",
  ContentTertiary: "var(--content-tertiary)",
  ContentError: "var(--content-error)",
  ContentWarning: "var(--content-warning)",
  ContentSuccess: "var(--content-success)",
  ContentInfo: "var(--content-info)",
  ContentBrand: "var(--content-brand)",
  ContentOnPhoto: "var(--content-on-photo)",
  ContentOnSurfaceBrand: "var(--content-on-surface-brand)",
  ContentOnSurfaceActionPrimary: "var(--content-on-surface-action-primary)",
  ContentOnSurfaceActionSecondary: "var(--content-on-surface-action-secondary)",
  ContentOnSurfaceInfo: "var(--content-on-surface-info)",
  ContentActionDefault: "var(--content-action-default)",
  ContentActionDefaultHover: "var(--content-action-default-hover)",
  ContentActionInactive: "var(--content-action-inactive)",
  ContentOnSurfaceActionInactive: "var(--content-on-surface-action-inactive)",
  ContentPermaWhite: "var(--content-perma-white)",
  ContentOnSurfacePermaWhite: "var(--content-on-surface-perma-white)",
  ContentOnSurfaceError: "var(--content-on-surface-error)",
  BorderPrimary: "var(--border-primary)",
  BorderSecondary: "var(--border-secondary)",
  BorderTertiary: "var(--border-tertiary)",
  BorderNeutralHighContrast: "var(--border-neutral-high-contrast)",
  BorderNeutralMediumContrast: "var(--border-neutral-medium-contrast)",
  BorderNeutralLowContrast: "var(--border-neutral-low-contrast)",
  BorderError: "var(--border-error)",
  BorderWarning: "var(--border-warning)",
  BorderSuccess: "var(--border-success)",
  BorderBrand: "var(--border-brand)",
  BorderPermaWhite: "var(--border-perma-white)",
  SurfacePermaWhite: "var(--surface-perma-white)",
  SurfacePermaDark: "var(--surface-perma-dark)",
  SurfacePermaBlack: "var(--surface-perma-black)",
  SurfaceTransparent: "var(--surface-transparent)",
  SurfaceActionPrimary: "var(--surface-action-primary)",
  SurfaceActionPrimaryHover: "var(--surface-action-primary-hover)",
  SurfaceActionSecondary: "var(--surface-action-secondary)",
  SurfaceActionSecondaryHover: "var(--surface-action-secondary-hover)",
  SurfaceActionBrand: "var(--surface-action-brand)",
  SurfaceActionBrandHover: "var(--surface-action-brand-hover)",
  SurfaceActionInactive: "var(--surface-action-inactive)",
  SurfaceActionInvert: "var(--surface-action-invert)",
  SurfaceActionInvertHover: "var(--surface-action-invert-hover)",
  SurfaceActionUnselected: "var(--surface-action-unselected)",
  SurfaceActionSelected: "var(--surface-action-selected)",
  SurfaceNeutralLowContrast: "var(--surface-neutral-low-contrast)",
  SurfaceNeutralMediumContrast: "var(--surface-neutral-medium-contrast)",
  SurfaceNeutralHighContrast: "var(--surface-neutral-high-contrast)",
  SurfaceError: "var(--surface-error)",
  SurfaceWarning: "var(--surface-warning)",
  SurfaceSuccess: "var(--surface-success)",
  SurfaceInfo: "var(--surface-info)",
  SurfaceHighlightLowContrast: "var(--surface-highlight-low-contrast)",
  SurfaceHighlightMediumContrast: "var(--surface-highlight-medium-contrast)",
  SurfaceColorSwatchDefault: "var(--surface-color-swatch-default)",
  SurfaceColorSwatch1: "var(--surface-color-swatch-1)",
  SurfaceColorSwatch2: "var(--surface-color-swatch-2)",
  SurfaceColorSwatch3: "var(--surface-color-swatch-3)",
  SurfaceColorSwatch4: "var(--surface-color-swatch-4)",
  SurfaceColorSwatch5: "var(--surface-color-swatch-5)",
  SurfaceColorSwatch6: "var(--surface-color-swatch-6)",
  SurfaceColorSwatch7: "var(--surface-color-swatch-7)",
  SurfaceColorSwatch8: "var(--surface-color-swatch-8)",
  SurfaceColorSwatch9: "var(--surface-color-swatch-9)"
};

export { DsmColor };
